__turbopack_context__.v({
  "barIcon": "ExplainerShell-module__iA41aW__barIcon",
  "caret": "ExplainerShell-module__iA41aW__caret",
  "contentsBtn": "ExplainerShell-module__iA41aW__contentsBtn",
  "crumbCurrent": "ExplainerShell-module__iA41aW__crumbCurrent",
  "crumbIcon": "ExplainerShell-module__iA41aW__crumbIcon",
  "crumbLink": "ExplainerShell-module__iA41aW__crumbLink",
  "crumbText": "ExplainerShell-module__iA41aW__crumbText",
  "crumbs": "ExplainerShell-module__iA41aW__crumbs",
  "explainerSheetFadeIn": "ExplainerShell-module__iA41aW__explainerSheetFadeIn",
  "explainerSheetSlideUp": "ExplainerShell-module__iA41aW__explainerSheetSlideUp",
  "footerRule": "ExplainerShell-module__iA41aW__footerRule",
  "layout": "ExplainerShell-module__iA41aW__layout",
  "layoutInner": "ExplainerShell-module__iA41aW__layoutInner",
  "main": "ExplainerShell-module__iA41aW__main",
  "mobileBar": "ExplainerShell-module__iA41aW__mobileBar",
  "mobileSearch": "ExplainerShell-module__iA41aW__mobileSearch",
  "page": "ExplainerShell-module__iA41aW__page",
  "sep": "ExplainerShell-module__iA41aW__sep",
  "sheet": "ExplainerShell-module__iA41aW__sheet",
  "sheetBackdrop": "ExplainerShell-module__iA41aW__sheetBackdrop",
  "sheetBody": "ExplainerShell-module__iA41aW__sheetBody",
  "sheetGrip": "ExplainerShell-module__iA41aW__sheetGrip",
  "sidebarColumn": "ExplainerShell-module__iA41aW__sidebarColumn",
  "sidebarFloat": "ExplainerShell-module__iA41aW__sidebarFloat",
  "tocColumn": "ExplainerShell-module__iA41aW__tocColumn",
  "tocFloat": "ExplainerShell-module__iA41aW__tocFloat",
});
